import * as React from 'react';
import {Query} from 'react-apollo';

import type {SlackChannelsQuery as SlackChannelsQueryQuery} from 'nutshell-graphql-types';

import {GraphQLSelect} from './graphql-select';
import GET_SLACK_CHANNELS from './queries/slackChannels.graphql';

class SlackChannelsQuery extends Query<SlackChannelsQueryQuery, Record<any, any>> {}

type Props = {
    selectedId: string | null | undefined;
    onChange: (newValue: any) => any;
    onClearValue?: () => void;
    labelKey?: string;
    valueKey?: string;
    autoFocus?: boolean;
    autoBlur?: boolean;
    isLoading?: boolean;
    noResultsText?: string;
    styles?: any;
    menuPortalTarget?: HTMLElement;
    defaultsToFirstItem?: boolean;
};

export const GraphQLSelectSlackChannels = (props: Props) => (
    // @ts-expect-error
    <SlackChannelsQuery query={GET_SLACK_CHANNELS} fetchPolicy='cache-and-network'>
        {({data, loading}) => {
            const slackChannels = data ? data.slackChannels : null;

            return (
                <GraphQLSelect
                    {...props}
                    isLoading={loading}
                    // @ts-expect-error
                    openMenuOnFocus={true}
                    placeholder='Search Slack channels…'
                    labelKey='display'
                    valueKey='externalId'
                    models={slackChannels || []}
                />
            );
        }}
    </SlackChannelsQuery>
);
